import illustration1 from "assets/about-us-illustration-1.png";
import illustration2 from "assets/about-us-illustration-2.png";
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import jagoba from "assets/jagoba-photo.png";
import ruben from "assets/ruben-photo.png";
import "./AboutUs.scss";

export const AboutUs = () => {


  return (
    <div className="about-us-container">
      <div className="what-are-we-looking-for">
        <div className="text-container">
          <span className="text-title">¿Qué buscamos?</span>
          <p>Nuestro objetivo como empresa es desarrollar un sistema de
            consumo responsable donde nuestros usuarios puedan disfrutar
            de una economía adaptada a sus necesidades y que les permita
            no solo ahorrar, sino también obtener ingresos de los artículos que
            deseen ceder a otros usuarios.</p>
        </div>
        <img src={illustration1} alt="about-us-illustration-1" />
      </div>
      <div className="how-it-works">
        <div className="illustration-container">
          <img src={illustration2} alt="about-us-illustration-2" />
        </div>
        <div className="text-container">
          <span className="text-title">¿Cómo funciona?</span>
          <p>Muy sencillo, simplemente te registras y ya puedes acceder a un amplio catálogo
            de artículos a los que puedes acceder a un precio asequible. En caso de querer
            añadir algún artículo, tendrás acceso a la opción en el menú central junto con
            otra variedad de opciones que se te ofrecen.</p>
          <p>Una vez hayas decidido qué publicar, deberás indicarnos el precio de alquiler y de
            compra (en csod e querer venderlo también, es opcional) junto con una fianza que
            servirá como método de seguro para asegurar los artículos que se ofrecen y el
            método de envío. Una vez publicado, te llegarán solicitudes de reserva de diferentes
            personas interesadas en adquirir tu artículo y podrás aceptar o rechazar las reservas.</p>
        </div>
      </div>
      <div className="our-team">
        <span className="text-title">Nuestro equipo</span>
        <p>Este es actualmente nuestro equipo:</p>
        <div className="team-members">
          <div>
            <div className="team-image">
              <img src={jagoba} alt="team-member-1" />
            </div>
            <span>Jagoba Abrisketa Cuesta</span>
            <p>Diseñador UX/UI</p>
            <div className="member-media">
              <div>
                <LinkedInIcon />
                <span>Jagoba Abrisketa</span>
              </div>
              <div>
                <MailOutlineIcon />
                <span>jagoba.abrisketa@gmail.com</span>
              </div>
            </div>
          </div>
          <div>
            <div className="team-image">
              <img src={ruben} alt="team-member-2" />
            </div>
            <span>Rubén Gutiérrez Ruiz</span>
            <p>Ingeniero de software</p>
            <div className="member-media">
              <div>
                <LinkedInIcon />
                <span>Rubén Gutiérrez Ruiz</span>
              </div>
              <div>
                <MailOutlineIcon />
                <span>rubengutierrezcm@gmail.com</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};